var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import defaultPreferencesDialogTemplate from '../consts/default-preferences-template';
var saveCustomPreferences = function (value) {
    if (value === void 0) { value = null; }
    var forcePreferences = Cookies.get('force-segment') === 'true';
    return defaultPreferencesDialogTemplate.categories.reduce(function (acc, cur) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[cur.key] = forcePreferences || value, _a)));
    }, {});
};
export default saveCustomPreferences;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2F2ZUN1c3RvbVByZWZlcmVuY2VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL3NhdmVDdXN0b21QcmVmZXJlbmNlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBLE9BQU8sT0FBTyxNQUFNLFdBQVcsQ0FBQztBQUVoQyxPQUFPLGdDQUFnQyxNQUFNLHdDQUF3QyxDQUFDO0FBRXRGLElBQU0scUJBQXFCLEdBQUcsVUFBQyxLQUFxQjtJQUFyQixzQkFBQSxFQUFBLFlBQXFCO0lBQ2xELElBQU0sZ0JBQWdCLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxlQUFlLENBQUMsS0FBSyxNQUFNLENBQUM7SUFDakUsT0FBTyxnQ0FBZ0MsQ0FBQyxVQUFVLENBQUMsTUFBTSxDQUN2RCxVQUFDLEdBQUcsRUFBRSxHQUFHOztRQUFLLE9BQUEsdUJBQ1QsR0FBRyxnQkFDTCxHQUFHLENBQUMsR0FBRyxJQUFHLGdCQUFnQixJQUFJLEtBQUssT0FDcEM7SUFIWSxDQUdaLEVBQ0YsRUFBRSxDQUNILENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLHFCQUFxQixDQUFDIn0=